import { Measure } from '@cbsi-cbscom/measure';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { VideoAPIInterrupt } from 'tag/ts/tag/api/video/VideoAPIInterrupt';
import { VideoAPIUtilities } from 'tag/ts/tag/api/video/VideoAPIUtilities';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
export class VideoAPI extends AbstractTagClass {
    #loadThrottler;
    #LOAD_THROTTLE_MS = 500;
    #videoAPIUtilities;
    #VideoAPIInterrupt;
    constructor(argument) {
        super({
            ...argument,
            name: 'VideoAPI'
        });
        this.#videoAPIUtilities = new VideoAPIUtilities({ tag: this.tag });
        let loadThrottleMS = this?.tag?.params?.TAG?.loadingThrottleMS || this.#LOAD_THROTTLE_MS;
        if (this?.tag?.params?.TAG?.loadingThrottleEnabled === false) {
            loadThrottleMS = 0;
        }
        this.#loadThrottler = new this.utils.Function.Throttler(loadThrottleMS);
        this.#VideoAPIInterrupt = new VideoAPIInterrupt({ tag: this.tag });
    }
    get IN() {
        return {
            load: (incomingParamsVO = {}, callbacksVO = {}, onceSettings = {}) => {
                const loadExecute = () => {
                    this?.logger?.log('load:', 'paramsVO:', incomingParamsVO, 'callbacksVO:', callbacksVO, 'onceSettings:', onceSettings);
                    Measure.end(Metrics.createToLoadTime);
                    Measure.start(Metrics.loadToAttachResourceTime);
                    delete incomingParamsVO.TAG;
                    delete incomingParamsVO.SKIN;
                    incomingParamsVO = this.tag.tagUtilities.normalizeParams(incomingParamsVO);
                    this.tag.callbacks = this.tag.tagUtilities.mergeCallbacks(this.tag.callbacks, callbacksVO);
                    if (this.utils.Type.isObject(onceSettings)) {
                        this.tagMVC.model.onceSettingsManager.onceSettings = this.utils.DeepMerge.deepmerge(this.tagMVC.model.onceSettingsManager.onceSettings, onceSettings);
                    }
                    if (this?.tag?.params?.TAG?.loadingAnimationConfig?.backgroundImage?.enabled) {
                        this.#setLoadingAnimationBackgroundImage(incomingParamsVO);
                    }
                    return new Promise((resolve, reject) => {
                        this.#videoAPIUtilities.stopPlayer(incomingParamsVO).then((data) => {
                            this?.logger?.log('load:', 'stopPlayer: resolved:', data.msg);
                            this.utils.Delay.delay().then(() => {
                                this?.logger?.log('load:', 'dispatch:', TagEvent.ON_REQUEST_TO_CLEAR_ERROR);
                                this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_REQUEST_TO_CLEAR_ERROR, this.tag, {
                                    paramsVO: incomingParamsVO
                                }, this, this.name));
                            }).then(() => {
                                switch (this.#videoAPIUtilities.allowedToLoadVideo()) {
                                    case true:
                                        this?.logger?.log('load:', 'dispatch:', TagEvent.ON_API_LOAD_VIDEO_REQUEST);
                                        this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_API_LOAD_VIDEO_REQUEST, this.tag, {
                                            paramsVO: incomingParamsVO
                                        }, this, this.name));
                                        resolve({ msg: 'done' });
                                        break;
                                    case false:
                                        this?.logger?.warn('load:', 'not allowed to load video');
                                        reject({ msg: 'Video load was not allowed!', success: false });
                                        break;
                                }
                            });
                        }).catch((error) => {
                            this?.logger?.warn('load: ERROR:', error);
                        });
                    });
                };
                const loadReject = () => {
                    return Promise.reject(new Error('tag.API.VIDEO.load( params ) call was rejected due to rapid succession!'));
                };
                if (this.#loadThrottler.canExecute()) {
                    return loadExecute();
                }
                else {
                    return loadReject();
                }
            },
            getCurrentTime: () => {
                return this.tag?.controller?.playerManager?.currentTime;
            },
            interrupt: (argument) => {
                this.#VideoAPIInterrupt?.interrupt(argument);
            },
            interrupted: () => {
                return this.#VideoAPIInterrupt?.interrupted;
            }
        };
    }
    #setLoadingAnimationBackgroundImage = (paramsVO) => {
        if (!this.tag?.params?.CONTENT) {
            this.tag.params.CONTENT = {};
        }
        this.tag.params.CONTENT = {
            ...this?.tag?.params?.CONTENT,
            ...paramsVO?.CONTENT
        };
        const contentParams = this?.tag?.params?.CONTENT;
        const [apiMetadata] = contentParams?.apiMetadata ?? [];
        const isLive = contentParams?.isLive || apiMetadata?.isLive;
        const contentBackgroundImageURL = contentParams?.loadingAnimationBackgroundImageURL;
        const currentBackgroundImageURL = this?.tag?.view?.loadingAnimationManager?.backgroundImageURL;
        if (isLive) {
            this?.tag?.view?.loadingAnimationManager?.disableBackgroundImage();
        }
        else {
            if (this?.tag?.params?.TAG?.loadingAnimationConfig?.backgroundImage?.enabled) {
                this?.tag?.view?.loadingAnimationManager?.enableBackgroundImage();
            }
            if (this?.tag?.params?.TAG?.loadingAnimationConfig?.fadeIn?.enabled) {
                this?.tag?.view?.loadingAnimationManager?.enableFadeIn();
            }
            if (this.utils.URL.valid(contentBackgroundImageURL)
                &&
                    contentBackgroundImageURL !== currentBackgroundImageURL) {
                this?.tag?.view?.loadingAnimationManager?.setBackgroundImage(contentBackgroundImageURL);
            }
            else if (this.utils.URL.valid(apiMetadata?.thumbnail)
                &&
                    apiMetadata?.thumbnail !== currentBackgroundImageURL) {
                this?.tag?.view?.loadingAnimationManager?.setBackgroundImage(apiMetadata?.thumbnail);
            }
        }
    };
}
